import Table from '../../components/table'

function InContractTab(props: any) {


    
    return (
      
        
        <div>
     <Table
          data={props.data}
          getTablesValues={props.getTables}
          type={"incontract"}
          setSort={props.setSort}
          applySort={props.applySort}
            />
        </div>
        
  )
}

export default InContractTab